// @ts-nocheck 0645189d
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_textinput'],
      sections: [addPanel.sections.getSections().developer.textInputSection],
    };
  },
};
